<template lang="pug">
modal(:active="true", title="Confirmação", @close="close")
  div(slot="modal-body")
    p.text Você está
      span.text-bold &nbsp;informando a regularização
      span &nbsp;de sua notificação/auto
      span.text-bold &nbsp;{{ `${current.numero}/${current.ano}` }}
      span.text , e que a prefeitura pode realizar a vistoria para verificação.
    p.text.text-error Confirme somente se todos os requisitos da notificação foram atendidos.
    p.text Se houver alguma irregularidade seu pedido será
      span.text-bold &nbsp;indeferido.
    p.text Após confirmar não será possível reverter este processo.
    p.text Tem certeza que deseja continuar?
  div(slot="modal-footer")
    a.btn.btn-link.text-error(@click="close")
      i.fa.fa-close
      |
      | Cancelar
    button.btn.btn-primary(@click="regularizei")
      i.fa.fa-check
      |
      | Confirmar
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors";

export default {
  vuex: { docs: { state: ["current"], actions: ["fetchRegularizar"] } },
  methods: {
    async regularizei() {
      try {
        await this.fetchRegularizar(this.current.id);
        this.$toaster.success(
          "Enviado com sucesso. Em breve um fiscal verificará sua regularização"
        );
        this.close();
      } catch (e) {
        toastErrors([e]);
      }
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
